<script>
export default {
	data() {
		return {
			isTablet: false,
			isMob: false
		};
	},

	created() {
		this.checkBreakpoints();
		this.$root.emitter.on('updateBreakpoints', () => this.checkBreakpoints());
	},

	methods: {
		checkBreakpoints() {
			this.isTablet = window.innerWidth <= 1279;
			this.isMob = window.innerWidth <= 767;
		}
	}
};
</script>